// extracted by mini-css-extract-plugin
export default {"MinorSlider_container":"MinorSlider_MinorSlider_container__1QEOt","MinorSlider_subContainer":"MinorSlider_MinorSlider_subContainer__k+7xK"};